
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/youtube","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"BG 127","d":"M0 0h20v20H0z","fill":"none","opacity":".58"}}),_c('path',{attrs:{"d":"M14.167 17.416H5.834a4.888 4.888 0 01-3.551-1.365A4.888 4.888 0 01.917 12.5v-5a4.888 4.888 0 011.366-3.551 4.888 4.888 0 013.551-1.366h8.333a4.888 4.888 0 013.551 1.366A4.888 4.888 0 0119.083 7.5v5a4.888 4.888 0 01-1.365 3.551 4.888 4.888 0 01-3.551 1.365zM5.834 4.083A3.2 3.2 0 002.417 7.5v5a3.2 3.2 0 003.417 3.417h8.333a3.2 3.2 0 003.417-3.417v-5a3.2 3.2 0 00-3.417-3.417z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.826 6.939a2.092 2.092 0 011.074.326l2.061 1.234a1.786 1.786 0 01.952 1.5 1.784 1.784 0 01-.949 1.5L9.9 12.735a2.09 2.09 0 01-1.076.326 1.641 1.641 0 01-1.574-1.827V8.759a1.636 1.636 0 011.576-1.82zm0 4.622a.637.637 0 00.3-.113l2.064-1.233c.175-.106.221-.2.223-.216s-.048-.108-.226-.216L9.131 8.552a.64.64 0 00-.305-.113h-.012a.592.592 0 00-.064.32v2.475a.606.606 0 00.065.327z","fill":"#fff","opacity":".4"}})])
          )
        }
      }
    